<template>
  <v-dialog
    class='service-filter-popup'
    :value="visiblePopup"
    :max-width="400"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='service-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="(service, index) in serviceOptions"
            :key="index"
            @click='addChip(service)'
            class='service'
            :class="service"
          >
            <span v-if="service !== 'No Service'" class="service__icon" :class="getIconStyle(service)"/>
            {{ service }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import {mapGetters} from 'vuex';
import {SERVICE_TYPES} from '@/constants/configuration';

export default {
  name: 'SelectServicesFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedService: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedService);
      this.selectedService = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedService = [];
    },
    addChip(service) {
      if (this.selectedService.includes(service)) {
        this.selectedService = this.selectedService.filter(item => item !== service);
      } else {
        this.selectedService.push(service);
      }
    },
    getIconStyle(service) {
      if (service !== 'No Service') {
        if (SERVICE_TYPES[service]) {
          return `cloud-service-icon ${SERVICE_TYPES[service].icon}`;
        }
        return 'cloud-service-icon service-icon-unknown';
      }
      return 'empty';
    },
  },
  computed: {
    ...mapGetters([
      'servicesOptions',
    ]),
    serviceOptions() {
      const options = [...this.servicesOptions];
      options.push('No Service');
      return options;
    },
    saveDisabled() {
      return this.selectedService.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.popup-wrapper {
  padding: rem(32) rem(40);

  .service-wrapper {
    margin-bottom: $space-2;

    .service {
      margin-bottom: rem(6);
      color: var(--text-secondary);
      background-color: var(--bg-tertiary);

      &__icon {
        width: rem(15);
        margin-right: rem(20);
      }
    }
  }

  .title {
    color: var(--text-primary);
    font-size: rem(14);
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: rem(16);
    text-transform: uppercase;
    padding-bottom: rem(23);
  }

  .buttons {
    text-align: right;
    padding-top: rem(30);

    .yes-button {
      margin-left: rem(8);
    }
  }
}
</style>
